import { useEffect, useRef, useState } from "react";

const ResponsiveAdBanner = ({ position = "default", adKey = null }) => {
  const adRef = useRef();
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [adWidth, setAdWidth] = useState(728);
  const [adHeight, setAdHeight] = useState(90);
  const instanceId = useRef(`ad_${Date.now()}_${Math.floor(Math.random() * 1000)}`);

  // Manejo del resize
  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const loadAd = () => {
    // Configuración específica por posición
    let adConfig;
    
    if (adKey) {
      // Usar clave personalizada si se proporciona
      adConfig = screenWidth >= 1024
        ? {
            key: adKey,
            format: "iframe",
            width: 728,
            height: 90,
          }
        : {
            key: adKey,
            format: "iframe", 
            width: 468,
            height: 60,
          };
    } else {
      // Configuraciones por defecto
      adConfig = screenWidth >= 1024
        ? {
            key: "87b8b5c9f03405ce31ecbdcd7831da6d",
            format: "iframe",
            width: 728,
            height: 90,
          }
        : {
            key: "32801cdd7df215ebcfd7267d194c9c32",
            format: "iframe",
            width: 468,
            height: 60,
          };
    }

    setAdWidth(adConfig.width);
    setAdHeight(adConfig.height);

    if (adRef.current) {
      // Limpiar contenido anterior
      adRef.current.innerHTML = "";
      
      // Crear un contenedor único para este anuncio
      const adContainer = document.createElement('div');
      adContainer.id = instanceId.current;
      
      // Configurar atOptions globalmente justo antes de cargar el script
      window.atOptions = {
        'key': adConfig.key,
        'format': adConfig.format,
        'height': adConfig.height,
        'width': adConfig.width,
        'params': {}
      };

      // Crear y añadir el script
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.src = `//www.highperformanceformat.com/${adConfig.key}/invoke.js?t=${Date.now()}`;
      script.async = true;
      
      // Manejar la carga del script
      script.onload = () => {
        console.log(`Ad loaded for position: ${position}`);
      };
      
      script.onerror = () => {
        console.error(`Failed to load ad for position: ${position}`);
        // Mostrar placeholder en caso de error
        if (adRef.current) {
          adRef.current.innerHTML = `
            <div style="
              width: ${adConfig.width}px; 
              height: ${adConfig.height}px; 
              background: #333; 
              border: 1px dashed #666; 
              display: flex; 
              align-items: center; 
              justify-content: center; 
              color: #999;
              font-size: 12px;
            ">
              Ad Space (${adConfig.width}x${adConfig.height})
            </div>
          `;
        }
      };

      adContainer.appendChild(script);
      adRef.current.appendChild(adContainer);
    }
  };

  // Cargar ad con diferentes delays según posición
  useEffect(() => {
    const delays = {
      top: 500,
      middle: 1000,
      bottom: 1500,
      game: 200,
      default: 500
    };

    // Offset del intervalo para que no refresquen todos al mismo tiempo
    const intervalOffsets = {
      top: 0,
      middle: 10000,
      bottom: 20000,
      game: 5000,
      default: 0
    };

    const delay = delays[position] || delays.default;
    const intervalOffset = intervalOffsets[position] || 0;

    const timer = setTimeout(() => {
      loadAd();
    }, delay);

    const interval = setInterval(() => {
      setTimeout(() => loadAd(), intervalOffset);
    }, 120000);

    return () => {
      clearTimeout(timer);
      clearInterval(interval);
    };
  }, [screenWidth, position]);

  // Cleanup al desmontar
  useEffect(() => {
    return () => {
      if (adRef.current) {
        adRef.current.innerHTML = "";
      }
    };
  }, []);

  return (
    <div className="w-full flex justify-center items-center my-2">
      <div
        ref={adRef}
        style={{ 
          width: adWidth, 
          height: adHeight,
          minHeight: adHeight,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        className="rounded-lg overflow-hidden bg-gray-800/50 border border-gray-600/30"
      />
    </div>
  );
};

export default ResponsiveAdBanner;